import React from 'react'
import AudioPlayer from '../components/AudioPlayer'

function Beats() {

    return (

        <div className="backhome">

            <AudioPlayer />
            
        </div>
    )
}


export default Beats;